import {InjectionToken, Provider} from '@angular/core';
export let LOCATION_SERVICE: any = new InjectionToken<any>('tt.locationService');

export function locationServiceFactory(i: any): any {
	return i.get('$location');
}

export const locationServiceProvider: Provider = {
	provide: LOCATION_SERVICE,
	useFactory: locationServiceFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/location.service.ts